module.exports = __webpack_public_path__ + "static/media/bg_vida.3bd7d708.png";